<div class="widgets-header-column" [ngClass]="clickedElementClass" [ngStyle]="!isSelectable ? { cursor: 'initial'}: ''">
  <app-single-widgets-bar-content [widgetContentData]="widgetData"></app-single-widgets-bar-content>
</div>
